import React from "react";
import FilterList from "../../../components/user/stopHistory/stopHistoryFilterList";
import Layout from "../../../components/layouts/verticalLayout";

const OutListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

OutListPage.propTypes = {};

export default OutListPage;
